(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hc-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hc-hero-slider')) {
    class HcHeroSlider extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.hc-hero-slide'));
        if (this.slides.length < 2) return;
        this.dots = Array.from(this.querySelectorAll('.hc-hero-dot'));
        this.markReady = () => this.setAttribute('data-ready', '');
        if (document.readyState === 'complete') setTimeout(this.markReady, 0);
        else window.addEventListener('load', () => setTimeout(this.markReady, 0), { once: true });
        this.toggle = this.querySelector('.hc-hero-toggle');
        this.index = 0;
        this.holds = new Set();
        this.delay = Math.max(3, parseInt(this.dataset.interval, 10) || 6) * 1000;
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.userPaused = !this.hasAttribute('data-autoplay') || reduce;

        this.dots.forEach((dot, i) => dot.addEventListener('click', () => { this.go(i); this.restart(); }));
        if (this.toggle) {
          this.toggle.addEventListener('click', () => { this.userPaused = !this.userPaused; this.updateToggle(); this.restart(); });
          this.updateToggle();
        }
        this.addEventListener('focusin', (e) => { if (e.target.matches(':focus-visible')) this.hold('focus', true); });
        this.addEventListener('focusout', (e) => { if (!this.contains(e.relatedTarget)) this.hold('focus', false); });
        this.addEventListener('touchstart', (e) => { const t = e.touches[0]; this.touch = { x: t.clientX, y: t.clientY }; }, { passive: true });
        this.addEventListener('touchend', (e) => {
          if (!this.touch) return;
          const t = e.changedTouches[0];
          const dx = t.clientX - this.touch.x;
          const dy = t.clientY - this.touch.y;
          this.touch = null;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { this.go(this.index + (dx < 0 ? 1 : -1)); this.restart(); }
        }, { passive: true });

        this.onVisibility = () => this.hold('hidden', document.hidden);
        document.addEventListener('visibilitychange', this.onVisibility);
        this.restart();
      }

      disconnectedCallback() {
        clearInterval(this.timer);
        if (!this.onVisibility) return;
        document.removeEventListener('visibilitychange', this.onVisibility);
      }

      go(i) {
        this.markReady();
        const n = this.slides.length;
        this.index = ((i % n) + n) % n;
        this.slides.forEach((slide, k) => slide.classList.toggle('is-active', k === this.index));
        this.dots.forEach((dot, k) => {
          if (k === this.index) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }

      hold(key, on) {
        if (on) this.holds.add(key); else this.holds.delete(key);
        this.restart();
      }

      restart() {
        clearInterval(this.timer);
        if (this.userPaused || this.holds.size) return;
        this.timer = setInterval(() => this.go(this.index + 1), this.delay);
      }

      updateToggle() {
        this.toggle.classList.toggle('is-paused', this.userPaused);
        this.toggle.setAttribute('aria-label', this.userPaused ? this.toggle.dataset.playLabel : this.toggle.dataset.pauseLabel);
      }
    }
    customElements.define('hc-hero-slider', HcHeroSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
